function camelToDash(str) {
    return str.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);
}

export { camelToDash };
//# sourceMappingURL=camel-to-dash.mjs.map
